import script from "./AddSearchFamilyMember.vue?vue&type=script&setup=true&lang=js"
export * from "./AddSearchFamilyMember.vue?vue&type=script&setup=true&lang=js"

import "./AddSearchFamilyMember.vue?vue&type=style&index=0&id=688a8a38&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-688a8a38"]])

export default __exports__